// src/utils/axios.js
import axios from 'axios'

// 创建实例
const instance = axios.create({
  // baseURL: 'http://47.105.109.229:1001/dev-api', // 正式测试
  baseURL: 'https://zhengwen.aitianqu.cn/dev-api', // 正式
  // baseURL: 'http://47.105.109.229:9999', // 测试
  timeout: 10000 // 超时时间
})

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 可以在这里加token等
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器
instance.interceptors.response.use(
  response => response.data,
  error => Promise.reject(error)
)

export default instance